export default __webpack_public_path__ + "static/media/serie1.b6e4f82f.png";